import { Construction } from "lucide-react";

export default function ComingSoon({ title, description, icon: Icon = Construction }) {
  const slug = (title || "").toLowerCase().replace(/\s+/g, "-");
  return (
    <div data-testid={`coming-soon-${slug}`} className="min-h-[60vh] flex items-center justify-center">
      <div className="lm-card p-10 max-w-md text-center">
        <div className="w-16 h-16 rounded-2xl bg-lm-sandsoft flex items-center justify-center mx-auto mb-5">
          <Icon className="w-8 h-8 text-lm-brown" />
        </div>
        <span className="inline-block text-[11px] font-bold uppercase tracking-[0.18em] text-lm-terra bg-lm-terra/10 rounded-full px-3 py-1 mb-3">
          In arrivo
        </span>
        <h1 className="font-display text-3xl text-lm-brown mb-2">{title}</h1>
        <p className="text-sm text-lm-muted leading-relaxed">
          {description || `Il modulo "${title}" sarà presto disponibile. Stiamo lavorando per portarlo online.`}
        </p>
      </div>
    </div>
  );
}
